<template>
  <div class="box" @click="goBack">
    <ion-icon src="/assets/icon/arrow-back-outline.svg"></ion-icon>
    <span>返回</span>
  </div>
</template>

<script>
import {IonIcon} from "@ionic/vue";
import router from "../../router";

export default {
  name: "BackButton",
  components: {
    IonIcon
  },
  props: {
    back_url: {type: String}
  },
  methods: {
    goBack: function () {
      if (this.back_url) {
        router.replace('/'+this.back_url)
      }
    }
  }
}
</script>

<style scoped>
  .box{
    position: fixed;
    top: calc(env(safe-area-inset-top) + 5.75rem);
    right: calc(env(safe-area-inset-right) + 0.75rem);
    z-index: 20;
    display: flex;
    align-items: center;
    gap: 0.25rem;
    justify-content: center;
    min-width: clamp(4.25rem, 8vw, 5.5rem);
    height: clamp(2rem, 4vw, 3rem);
    padding: 0 clamp(0.625rem, 1.5vw, 0.875rem);
    color: white;
    font-size: var(--ecs-font-md);
    font-weight: 700;
    line-height: 1.2;
    background: rgba(96, 96, 96, 0.86);
    border-radius: 999px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
    cursor: pointer;
  }
</style>
